/** Left navigation rail. */
import { useEffect, useState } from 'react';
import { NAV } from '../lib/nav';
import { cx } from '../ui';
import { Logo } from './Logo';

/** The commit this UI was built from (baked in by vite.config.ts). */
const UI_COMMIT = typeof __CATI_COMMIT__ === 'string' ? __CATI_COMMIT__ : 'dev';

/**
 * Build stamp: the UI's own commit, and the API's (read from /health, which nginx
 * already proxies). If they differ, one side wasn't redeployed/restarted — say so,
 * because a green-looking console on stale code is exactly what wastes an afternoon.
 */
function BuildStamp() {
  const [api, setApi] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    fetch('/health')
      .then((r) => (r.ok || r.status === 503 ? r.json() : null))
      .then((d) => live && setApi(typeof d?.version === 'string' ? d.version : 'unknown'))
      .catch(() => live && setApi('unreachable'));
    return () => {
      live = false;
    };
  }, []);
  const mismatch = api !== null && api !== 'unknown' && api !== 'unreachable' && api !== UI_COMMIT;
  return (
    <div className="mt-auto border-t border-line px-4 py-3 text-[11px] text-faint">
      <div>cati-db console · v2</div>
      <div className="mono mt-1 text-[10.5px]">
        ui {UI_COMMIT}
        {api !== null && (
          <>
            {' · api '}
            {api}
          </>
        )}
        {mismatch && <span className="text-bad"> · ⚠ mismatch</span>}
      </div>
    </div>
  );
}

export default function Rail({ view, onNav }: { view: string; onNav: (id: string) => void }) {
  return (
    <aside className="flex flex-col overflow-y-auto border-r border-line bg-panel">
      <div className="flex items-center gap-2.5 border-b border-line px-4 py-3.5">
        <Logo />
        <b className="text-[14px] tracking-wide">CATI-DB</b>
      </div>
      <nav className="px-2.5 py-3">
        {NAV.map((g) => (
          <div key={g.group} className="mb-2.5">
            <span className="block px-2 pb-1.5 text-[10.5px] uppercase tracking-widest text-faint">{g.group}</span>
            {g.items.map((it) => (
              <button key={it.id} className={cx('navitem', view === it.id && 'active')} onClick={() => onNav(it.id)}>
                {it.label}
                {it.tag && <span className="tag">{it.tag}</span>}
              </button>
            ))}
          </div>
        ))}
      </nav>
      <BuildStamp />
    </aside>
  );
}
